 import { Button } from "../../../components/ui/button"; 
 export const columns = [
        { key: "lab_name", label: "Lab Name" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        { key: "address", label: "Address" },
        {
            key: "status",
            label: "Status",
            render: (row) => (
                <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold
        ${row.status === "active"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                >
                    {row.status === "active" ? "Active" : "Inactive"}
                </span>
            ),
        },

        {
            key: "edit",
            label: "Edit",
            render: () => (
                <Button className="bg-yellow-400 hover:bg-yellow-500 text-black h-8 px-4">
                    Edit
                </Button>
            ),
        },
    ];

    export const data = [
        {
            lab_name: "LifeCare Diagnostics",
            email: "amit@hospital.com",
            phone: "9876543210",
            address: "Main Road, Patna",
            status: "active"
        }
    ];
